export default {
    main: {
        首页: 'HomePage',
        订单生成中: 'Order generating',
        请稍候: 'Please wait...',
        安全支付: 'Secure Payment',
        订单号: 'Mã đơn hàng',
        金额: 'Số lượng',
        支付提示: 'Mẹo',
        请在: 'vui lòng hoàn tất thanh toán sau ',
        秒内: ' giây ',
        完成: ' ',
        支付: ' ',
        超时会自动: 'thời gian chờ sẽ tự động hủy ',
        取消: 'cancel ',
        生成中请稍候: 'Tạo ra',
        剩余时间: 'Thời gian còn lại',
        订单已失效: 'Order expired',
        订单已失效Memo: 'Please place an order again or wait for the payment to arrive !',
        订单异常: 'Order Abnormality',
        发生错误: 'An error occurred',
        订单生成失败: 'Order generation failed',
        暂无可用的订单: 'No orders available',
        订单: 'Đơn hàng ',
        已支付: 'đã được thanh toán ',
        已超时: 'đã hết thời gian ',
        生成失败: 'thế hệ thất bại ',
        已支付Memo: 'Đơn hàng của bạn đã được xác nhận là đã thanh toán thành công. Vui lòng đóng trang này và xác nhận đã nhận được tiền.',
        已超时Memo: 'Đơn hàng của bạn đã hết thời gian thanh toán. Vui lòng đóng trang này và đặt hàng lại.',
        生成失败Memo: 'Việc tạo đơn hàng của bạn không thành công. Vui lòng đóng trang này và đặt hàng lại.',
    }
}
